import * as Types from '../../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ConversationFragmentFragment = { __typename?: 'Conversation', id: string, uuid: string, name?: string | null, pinned: boolean, lastMessage?: { __typename?: 'ChatMessage', id: string, content: string, createdAt: number, from: { __typename?: 'User', id: string } } | null, members: Array<{ __typename?: 'ChatMember', id: string, lastReadMessageId?: string | null, profile: { __typename?: 'User', id: string, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null } }>, photo?: { __typename?: 'File', url: string, type: Types.FileType } | null, owner: { __typename?: 'User', id: string } };

export type GetUserConversationsQueryVariables = Types.Exact<{
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  chatsSearch?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetUserConversationsQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, conversations: Array<{ __typename?: 'Conversation', id: string, uuid: string, name?: string | null, pinned: boolean, lastMessage?: { __typename?: 'ChatMessage', id: string, content: string, createdAt: number, from: { __typename?: 'User', id: string } } | null, members: Array<{ __typename?: 'ChatMember', id: string, lastReadMessageId?: string | null, profile: { __typename?: 'User', id: string, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null } }>, photo?: { __typename?: 'File', url: string, type: Types.FileType } | null, owner: { __typename?: 'User', id: string } }> } };

export const ConversationFragmentFragmentDoc = gql`
    fragment ConversationFragment on Conversation {
  id
  uuid
  lastMessage {
    id
    content
    createdAt
    from {
      id
    }
  }
  members {
    id
    lastReadMessageId
    profile {
      id
      username
      photoUrl
      firstName
      lastName
    }
  }
  name
  pinned
  photo {
    url
    type
  }
  owner {
    id
  }
}
    `;
export const GetUserConversationsDocument = gql`
    query GetUserConversations($offset: Int, $limit: Int, $chatsSearch: String) {
  currentUser {
    id
    conversations(offset: $offset, limit: $limit, searchTerm: $chatsSearch) {
      ...ConversationFragment
    }
  }
}
    ${ConversationFragmentFragmentDoc}`;

/**
 * __useGetUserConversationsQuery__
 *
 * To run a query within a React component, call `useGetUserConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserConversationsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      chatsSearch: // value for 'chatsSearch'
 *   },
 * });
 */
export function useGetUserConversationsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserConversationsQuery, GetUserConversationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserConversationsQuery, GetUserConversationsQueryVariables>(GetUserConversationsDocument, options);
      }
export function useGetUserConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserConversationsQuery, GetUserConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserConversationsQuery, GetUserConversationsQueryVariables>(GetUserConversationsDocument, options);
        }
// @ts-ignore
export function useGetUserConversationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserConversationsQuery, GetUserConversationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserConversationsQuery, GetUserConversationsQueryVariables>;
export function useGetUserConversationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserConversationsQuery, GetUserConversationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserConversationsQuery | undefined, GetUserConversationsQueryVariables>;
export function useGetUserConversationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserConversationsQuery, GetUserConversationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserConversationsQuery, GetUserConversationsQueryVariables>(GetUserConversationsDocument, options);
        }
export type GetUserConversationsQueryHookResult = ReturnType<typeof useGetUserConversationsQuery>;
export type GetUserConversationsLazyQueryHookResult = ReturnType<typeof useGetUserConversationsLazyQuery>;
export type GetUserConversationsSuspenseQueryHookResult = ReturnType<typeof useGetUserConversationsSuspenseQuery>;
export type GetUserConversationsQueryResult = Apollo.QueryResult<GetUserConversationsQuery, GetUserConversationsQueryVariables>;